<template lang="pug">
  v-card.pa-6.round-xl(v-if="toDisplaySummary" outlined)
    // Email deliverance summary
    div.text-md.font-semibold.neutral700--text Email deliverance summary

    // Offer message
    template(v-if="hasOfferBlastEnabled")
      div.text-xs.font-bold.neutral700--text.mt-5 Offer email
      v-simple-table.custom-simple-table.mt-2(dense)
        thead
          tr
            th Customers
            th Frequency
            th.text-right Total email
        tbody
          tr
            td.text-sm.neutral700--text {{ totalSelectedCustomers | displayNumber }}
            td.text-sm.neutral700--text {{ offerBlastFrequency | displayNumber }}
            td.text-sm.neutral700--text.text-right {{ offerTotalMessage | displayNumber }}
      v-divider
    // Thank you message
    template(v-if="hasThankyouBlastEnabled")
      div.text-xs.font-bold.neutral700--text.mt-5 Thank you email
      v-simple-table.custom-simple-table.mt-2(dense)
        thead
          tr
            th Customers
            th Frequency
            th.text-right Total email
        tbody
          tr
            td.text-sm.neutral700--text {{ totalSelectedCustomers | displayNumber }}
            td.text-sm.neutral700--text {{ thankyouBlastFrequency | displayNumber }}
            td.text-sm.neutral700--text.text-right {{ thankyouTotalMessage | displayNumber }}
      v-divider
    // Total email
    div.d-flex.align-center.mt-6
      div.text-lg.font-bold.neutral700--text Total email:
      v-spacer
      div.text-lg.font-bold.neutral700--text {{ grandTotal | displayNumber }} emails
</template>


<script>
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters({
      company: 'getCompany',
      summary: 'marketing/getSummary',
      setting: 'marketing/getMarketingSettings',
      offer: 'marketing/getOffer',
      blasts: 'marketing/getBlasts'
    }),
    toDisplaySummary() {
      return this.offer.thankyou_msg_enabled && this.enabledBlasts.length > 0
    },
    totalSelectedCustomers() {
      if (this.offer.to_all_customers) {
        return this.summary.totalCustomers
      }
      let total = 0
      if (this.offer.to_all_loyalty_members) total += this.summary.totalLoyaltyMembers
      if (this.offer.groups && this.offer.groups.length > 0) total += this.offer.groups.length
      if (this.offer.customers && this.offer.customers.length > 0) total += this.offer.customers.length
      return total
    },
    enabledBlasts() {
      return this.blasts.filter(blast => blast.method === 'email' && blast.enabled)
    },
    offerBlast() {
      return this.enabledBlasts.find(blast => blast.type === 'offer') || null
    },
    thankyouBlast() {
      return this.enabledBlasts.find(blast => blast.type === 'thank_you') || null
    },
    hasOfferBlastEnabled() {
      return this.offerBlast !== null
    },
    hasThankyouBlastEnabled() {
      return this.thankyouBlast !== null
    },
    offerBlastFrequency() {
      return this.offerBlast?.frequency ?? 0
    },
    thankyouBlastFrequency() {
      return this.thankyouBlast?.frequency ?? 0
    },
    offerTotalMessage() {
      return this.totalSelectedCustomers * this.offerBlastFrequency
    },
    thankyouTotalMessage() {
      return this.totalSelectedCustomers * this.thankyouBlastFrequency
    },
    grandTotal() {
      return this.offerTotalMessage + this.thankyouTotalMessage
    },
  },
}
</script>

<style scoped>

</style>